import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'zzz', 'Zzz', [["path",{"d":"M4 12h6l-6 8h6"}],["path",{"d":"M14 4h6l-6 8h6"}]]);